import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hint-music-th-policy',
  templateUrl: './hint-music-th-policy.component.html',
  styleUrls: ['./hint-music-th-policy.component.css']
})
export class HintMusicThPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
